"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _solarReact = require("@solar/solar-react");

var _TodoMessage = _interopRequireDefault(require("./TodoMessage"));

var _excluded = ["title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Todo = function Todo(_ref) {
  var title = _ref.title,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveAppBar, {
    title: title
  }), /*#__PURE__*/_react["default"].createElement(_TodoMessage["default"], other));
};

Todo.propTypes = {
  title: _propTypes["default"].string
};
Todo.defaultProps = {
  title: 'TODO'
};
var _default = Todo;
exports["default"] = _default;